import { SearchFacetData } from 'modules/search/types/SearchFacetData';
import { AREAS_OF_FOCUS } from 'utils/constants/general/areasOfFocus';

export const orgAreasOfFocusFacet = {
  id: 'orgAreasOfFocusFacet',
  name: 'areasOfFocus',
  get title() {
    return getText('Cause Areas');
  },
  type: 'array',
  options: Object.keys(AREAS_OF_FOCUS),
  optionTitles: AREAS_OF_FOCUS,
} as const satisfies SearchFacetData;
